import { HistoryCard } from './HistoryCard';

const HISTORY_DATA = [
  {
    id: 8,
    year: 2025,
    history: (
      <div>
        <li>
          제휴계약 3건, 보유 회원 21,000+
          <br />
          <span className="pl-4">(더채플대치, 더베르지, 베스트웨스턴)</span>
        </li>
        <li>누적 근무자 계약 132,900+</li>
      </div>
    ),
  },
  {
    id: 1,
    year: 2024,
    history: (
      <div>
        <li>
          제휴 계약 4건, 보유 회원 18,500+
          <br />
          <span className="pl-4">(TMS, 더세인트, 더채플 논현, 더링크)</span>
        </li>
        <li>누적 근무자 계약 107,900+</li>
        <li>플랫폼 우구구 리뉴얼</li>
      </div>
    ),
  },
  {
    id: 2,
    year: 2023,
    history: (
      <div>
        <li>
          제휴 계약 4건, 보유 회원 14,500+
          <br />
          <span className="pl-4">(제이드 2건, 플로팅아일랜드, 더아너스)</span>
        </li>
        <li>누적 근무자 계약 80,000+</li>
      </div>
    ),
  },
  {
    id: 3,
    year: 2022,
    history: (
      <div>
        <li>
          제휴 계약 2건, 보유 회원 10,300+
          <br />
          <span className="pl-4">(테이크, 더 채플 청담)</span>
        </li>
        <li>누적 근무자 계약 63,700+</li>
        <li>아웃소싱 홈페이지 리뉴얼 및 확장</li>
        <li>신규 플랫폼 개설 및 어플리케이션 출시</li>
      </div>
    ),
  },
  {
    id: 4,
    year: 2021,
    history: (
      <div>
        <li>
          제휴 계약 5건, 보유 회원 7,800+ <br />{' '}
          <span className="pl-4">
            (더리버, 락구정, 아키텍처, 지타워, 삼청각)
          </span>
        </li>
        <li>누적 근무자 계약 43,200+</li>
      </div>
    ),
  },
  {
    id: 5,
    year: 2020,
    history: (
      <div>
        <li>
          제휴 계약 3건, 보유 회원 6,100+ <br />
          <span className="pl-4">(노블발렌티 청담/대치점, 루벨 강동)</span>
        </li>
        <li>누적 근무자 계약 31,100+</li>
        <li>더에스씨브이 홈페이지 개설</li>
      </div>
    ),
  },
  {
    id: 6,
    year: 2019,
    history: (
      <div>
        <li>
          제휴 계약 5건, 보유 회원 4,200+ <br />
          <span className="pl-4">
            (노블발렌티 삼성, 더라빌, 현대그린푸드, 애견협회, SL&C삼천리)
          </span>
        </li>
        <li>누적 근무자 계약 21,800+</li>
        <li>아웃소싱 홈페이지 개설</li>
      </div>
    ),
  },
  {
    id: 7,
    year: 2018,
    history: (
      <div>
        <li>주식회사 더에스씨브이 창사</li>
        <li>누적 근무자 계약 8,400+</li>
      </div>
    ),
  },
];

export const FourthSection = () => {
  return (
    <div
      className="mx-auto w-full max-w-screen-xl space-y-5 px-5 md:space-y-10"
      id="section4"
    >
      <p className="text-[26px] font-semibold md:text-[36px]">OUR HISTORY</p>

      <div className="grid grid-cols-1 gap-16 lg:grid-cols-2 xl:grid-cols-3">
        {HISTORY_DATA.map((hi) => (
          <HistoryCard key={hi.id} year={hi.year} history={hi.history} />
        ))}
      </div>
    </div>
  );
};

export default { FourthSection };
